var _circle, _circle2, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewPends({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 111,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 55.5,
    r: 55.5,
    fill: "#e59c27",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 55.5,
    r: 43.768,
    fill: "#e59c27",
    opacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64.978,
    height: 64.979,
    x: 23.964,
    y: 22.561,
    fill: "#e59c27",
    rx: 32.489
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#f7f8f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M50.452 53.05v-2c0-3.31 1-6 6-6s6 2.69 6 6v2m-1 12h-10c-4 0-5-1-5-5v-2c0-4 1-5 5-5h10c4 0 5 1 5 5v2c0 4-1 5-5 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#f7f8f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M60.449 59.05h.009m-4.01 0h.009m-4.01 0h.009"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPends);
export default __webpack_public_path__ + "static/media/newPends.bd88ab72b2c6f2ebffa83c8f22ed8aa0.svg";
export { ForwardRef as ReactComponent };